// Time Machine #114 — gate predicate for the header "🕒 Time Travel" button.
//
// Returns true ONLY when the user is logged in AND their Users document
// carries `timeTravelAccess: true` (strict equality — undefined, null,
// false, or any other truthy non-true value all hide the button).
//
// Why strict `=== true`:
//   - The seed migration (dbtools/src/mutations/users-add-timeTravelAccess.mjs)
//     stamps `false` on every Users doc. Admins flip selected users to `true`
//     in MongoDB Compass to grant access.
//   - Treating any-truthy as access would mean a future schema change that
//     stores e.g. a permission level string ("read", "admin") accidentally
//     opens the gate. Strict-true documents the intent.

export function canAccessTimeMachine(mongoUser, tsUserDocument) {
  return Boolean(mongoUser) && tsUserDocument?.timeTravelAccess === true;
}
